import { render, staticRenderFns } from "./select-project.vue?vue&type=template&id=122b5b22&scoped=true&"
import script from "./select-project.vue?vue&type=script&lang=js&"
export * from "./select-project.vue?vue&type=script&lang=js&"
import style0 from "./select-project.vue?vue&type=style&index=0&id=122b5b22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b5b22",
  null
  
)

export default component.exports